import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getAllActivity() {
  let response = {}
  try {
      response = await axios.get(`${config.eastCoastDataApi()}BaseData/Activity`)

  } catch (err) {
      console.error('iisi getAllActivity: ', err)
      Utils.setApiResponsSuccess(response)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function getActivityById(id = "123") {
  let response = {}
  if(Utils.isEmptyString(id)) {
    console.error('iisi getActivityById: id is null')
    Utils.setApiResponsSuccess(response)
    return response 
  }

  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/Activity/${id}`)

  } catch (err) {
      console.error('iisi getActivityById: ', err)
      Utils.setApiResponsSuccess(response)
      return null
  }

  Utils.setApiResponsSuccess(response)
  return response.data
}

export async function getActivity(condition = {}) {
  let response = {}

  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : moment(condition.startTime).startOf('day').format().split('+')[0]
  const startTimeQuery = Utils.isEmptyObject(startTime) ? '' : `StartTime=${encodeURIComponent(startTime)}&`
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : moment(condition.endTime).endOf('day').format().split('+')[0]
  const endTimeQuery = Utils.isEmptyObject(endTime) ? '' : `EndTime=${encodeURIComponent(endTime)}&`
  const activityName = Utils.isEmptyObject(condition.activityName) ? '' : condition.activityName
  const activityNameQuery = `ActivityName=${activityName}&`

  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/Activity?${startTimeQuery}${endTimeQuery}${activityNameQuery}`)

  } catch (err) {
      console.error('iisi getActivity: ', err)
      Utils.setApiResponsSuccess(response)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function postActivity(activity = {}) {
  let response = {}
  if(Utils.isEmptyObject(activity)) {
    console.error('iisi postActivity: activity is null')
    Utils.setApiResponsSuccess(response)
    return response 
  }

  // activity.startDate = moment(activity.startDate).startOf('day').format()
  // activity.endDate = moment(activity.endDate).endOf('day').format()
  activity.startDate = moment(activity.startDate).seconds(0).format()// 固定為任意HH:mm:00
  activity.endDate = moment(activity.endDate).format() // 固定為任意HH:mm:00
  try {
    response = await axios.post(`${config.eastCoastDataApi()}BaseData/Activity`, activity)

  } catch (err) {
      console.error('iisi postActivity: ', err)
      Utils.setApiResponsSuccess(response)
      return response
  }

  Utils.setApiResponsSuccess(response)
  putActivityDevice(response.data) // 依活動id設定關聯設備
  return response
}

export async function putActivity(activity = {}) {
  let response = {}
  
  if(Utils.isEmptyObject(activity) || Utils.isEmptyObject(activity.id)) {
    console.error('iisi putActivity: activity is null')
    Utils.setApiResponsSuccess(response)
    return response 
  }

  // activity.startDate = moment(activity.startDate).startOf('day').format()
  // activity.endDate = moment(activity.endDate).endOf('day').format()
  activity.startDate = moment(activity.startDate).seconds(0).format();
  activity.endDate = moment(activity.endDate).seconds(0).format();

  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/Activity/${activity.id}`, activity)

  } catch (err) {
      console.error('iisi putActivity: ', err)
      Utils.setApiResponsSuccess(response)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function putActivityDevice(activity = {}) {
  let response = {}
  
  if(Utils.isEmptyObject(activity) || Utils.isEmptyObject(activity.id)) {
    console.error('iisi putActivityDevice: activity is null')
    Utils.setApiResponsSuccess(response)
    return response 
  }

  const deviceIdList = ['cv99001', 'cv99002']
  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/Activity/${activity.id}/Devices`, deviceIdList)

  } catch (err) {
      console.error('iisi putActivityDevice: ', err)
      Utils.setApiResponsSuccess(response)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function deleteActivity(activity = {}) {
  let response = {}
  if(Utils.isEmptyObject(activity) || Utils.isEmptyObject(activity.id)) {
    console.error('iisi deleteActivity: activity is null')
    Utils.setApiResponsSuccess(response)
    return response 
  }

  try {
    response = await axios.delete(`${config.eastCoastDataApi()}BaseData/Activity/${activity.id}`)

  } catch (err) {
      console.error('iisi deleteActivity: ', err)
      Utils.setApiResponsSuccess(response)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}